import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  padding: 16px;
  background-color: #F8F8F8;
  display: ${({show}) => (show ? "block" : "none")};
`;

export const Title = styled.h1`
  font-size: 16px;
  font-weight: 600;
  margin: 8px 0;
`;

export const NumbersWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 16px;
`;

export const NumberDiv = styled.div`
  width: calc((100vw - 32px) / 11);
  height: calc(100vw / 8);
  flex-shrink: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: -2px;
`;

export const NumberSpan = styled.span`
  background-color: ${({color}) => color};
  font-size: ${({selected, size}) => selected ? size * 1.2 : size}px;
  font-weight: 600;
  color: #fff;
  height: ${({selected}) => selected ? '100%' : '80%'};
  width: ${({selected}) => selected ? '100%' : '80%'};
  min-height: 32px;
  min-width: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 3px;
  transition: 0.4s;
`;

export const JustificationInput = styled.input`
  width: 100%;
  height: 40px;
  margin-top: 16px;
  padding: 10px;
  border-radius: 8px;
  border: none;
  box-sizing: border-box;
  font-size: 14px;
  background-color: #eeeeee;
  transition: 0.4s;
  color: #2c2c2c;
  font-family: 'Ubuntu', sans-serif;
`;

export const MandatoryNpsLabel = styled.span`
  font-family: Roboto, sans-serif;
  font-size: 12px;
  color: #ee2b25;
  font-weight: 500;
  font-style: italic;
  margin-left: 4px;
`;